const inputObserver = new MutationObserver(() => {
  const unbxdInput = document.querySelector('.search-modal__form input[type="search"]');

  if (unbxdInput && !unbxdInput.dataset._observed) {
    unbxdInput.dataset._observed = true;

    document.addEventListener('input', function (event) {
      const input = event.target;
      if (input.matches('.search-modal__form input[type="search"]')) {
        const resetButton = document.querySelector('.search-modal__form .reset__button');
        
        input.addEventListener('input', (e) => {
          if(input.value.trim() !== '') {
            input.style.paddingRight = '40px';
          } 
        });

        resetButton.addEventListener('click', () => {
          if(input.value.trim() !== '') {
             input.style.paddingRight = '10px';
          } 
        });
       
        if (resetButton) {
          if (input.value.trim() !== '') {
            resetButton.style.display = 'block';
          } else {
            resetButton.style.display = 'none';
          }
        }
      }
    });

    const resetButton = document.querySelector('.search-modal__form .reset__button');
    if (resetButton) {
       resetButton.addEventListener('click', () => {
        unbxdInput.value = '';
        unbxdInput.dispatchEvent(new Event('input', { bubbles: true }));
        unbxdInput.focus();
      });
    }
  }
});

inputObserver.observe(document.body, {
  childList: true,
  subtree: true,
});